var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { URL_AVAILABILITY_HOTEL, MOCK_URL_AVAILABILITY_HOTEL_PROPERTIES_AND_FACILITIES, MOCK_STATUS, MOCK_URL_AVAILABILITY_HOTEL, MOCK_URL_AVAILABILITY_HOTEL_ROOMS, URL_AVAILABILITY_HOTEL_ROOMS } from '@ibe.config';
import { INDRAApiService } from '@ibe/services';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { extendMoment } from 'moment-range';
import * as Moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
import * as i3 from "@angular/platform-browser";
var moment = extendMoment(Moment);
var INDRABookingComService = /** @class */ (function () {
    function INDRABookingComService(api, http, sanitizer) {
        this.api = api;
        this.http = http;
        this.sanitizer = sanitizer;
        this.version = '2.6';
        this.base_url = 'https://distribution-xml.booking.com/';
        this.url = "" + this.base_url + this.version + "/json/";
        this.searchParam = {
            checkin: '',
            checkout: '',
            num_rooms: 0,
            room1: [],
            // room2: [],
            propertyType: [],
            hotelFacilities: [],
            minPrice: '',
            maxPrice: '',
            stars: [],
            locationValue: ''
        };
    }
    INDRABookingComService.prototype.blockAvailability = function (params) {
        if (params === void 0) { params = { checkin: '2020-06-01', checkout: '2020-06-30', hotel_ids: '257694' }; }
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('blockAvailability', { params: params })];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    INDRABookingComService.prototype.hotelAvailability = function (params) {
        if (params === void 0) { params = { city_ids: '-1565670', checkin: '2020-06-01', checkout: '2020-06-30', room1: 'A,A', extras: 'room_details,hotel_details', order_by: 'popularity', options: 'no_dorms' }; }
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('hotelAvailability', { params: params })];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    INDRABookingComService.prototype.city = function (params) {
        if (params === void 0) { params = { countries: 'pt', languages: 'pt' }; }
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('cities', { params: params })];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    INDRABookingComService.prototype.hotels = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('hotels', { params: params })];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    INDRABookingComService.prototype.regions = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('regions', { params: params })];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    INDRABookingComService.prototype.autocomplete = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('autocomplete', { params: params })];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    INDRABookingComService.prototype.request = function (endpoint, params, method) {
        if (method === void 0) { method = 'get'; }
        return __awaiter(this, void 0, void 0, function () {
            var url, defaultConfig, config, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + this.url + endpoint;
                        defaultConfig = {
                            baseURL: url,
                            method: method,
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                            },
                            auth: {
                                username: 'uxdapi',
                                password: 'uxdtap1t'
                            },
                            withCredentials: false,
                            responseType: 'json'
                        };
                        config = Object.assign(defaultConfig, params);
                        return [4 /*yield*/, axios.get(url, config)];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request.data.result || false];
                }
            });
        });
    };
    INDRABookingComService.prototype.INDRA_hotelAvailability = function (params) {
        if (MOCK_STATUS.AVAILABILITY_HOTEL) {
            return this.http.get(MOCK_URL_AVAILABILITY_HOTEL);
        }
        else {
            return this.api.INDRA_post(URL_AVAILABILITY_HOTEL, params);
        }
    };
    INDRABookingComService.prototype.INDRA_blockAvailability = function (params) {
        if (MOCK_STATUS.AVAILABILITY_HOTEL_ROOMS) {
            return this.http.get(MOCK_URL_AVAILABILITY_HOTEL_ROOMS);
        }
        else {
            return this.api.INDRA_post(URL_AVAILABILITY_HOTEL_ROOMS, params);
        }
    };
    INDRABookingComService.prototype.INDRA_getFacilitiesAndProperties = function () {
        return this.http.get(MOCK_URL_AVAILABILITY_HOTEL_PROPERTIES_AND_FACILITIES);
    };
    INDRABookingComService.prototype.INDRA_getGoogleLocation = function (address) {
        // const query = encodeURIComponent(address);
        // "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12451.321677960634!2d-9.158736573356403!3d38.721702214786895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd193378df121fc1%3A0xb57b449cd0d8a191!2sSanto%20Ant%C3%B3nio%2C%20Lisbon%2C%20Portugal!5e0!3m2!1sen!2sph!4v1591620991773!5m2!1sen!2sph"
        // `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12451.324594926295!2d-9.158736563706988!3d38.721685473568286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd193378df121fc1%3A0xb57b449cd0d8a191!2s${query}!5e0!3m2!1spt-PT!2spt!4v1580226794465!5m2!1spt-PT!2spt`
        // "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235666.45775262892!2d-43.44577868237182!3d-22.64303331183054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9972edfbe838f5%3A0x672bb060c280a52a!2sDuque%20de%20Caxias%2C%20State%20of%20Rio%20de%20Janeiro%2C%20Brazil!5e0!3m2!1sen!2sph!4v1591621131465!5m2!1sen!2sph"
        return this.sanitizer.bypassSecurityTrustResourceUrl("https://maps.google.com/?q=" + address + "&output=embed");
    };
    INDRABookingComService.prototype.setHotel = function (hotel) {
        this._hotel = hotel;
    };
    INDRABookingComService.prototype.getHotel = function () {
        return this._hotel;
    };
    INDRABookingComService.prototype.setSearchParam = function (param) {
        this.searchParam = param;
    };
    INDRABookingComService.prototype.getSearchParam = function () {
        return this.searchParam;
    };
    INDRABookingComService.prototype.generateSearchParam = function (searchParam) {
        var room1 = [];
        for (var i = 0; i < searchParam.passengers.adults; i++) {
            room1.push('A');
        }
        for (var i = 0; i < searchParam.passengers.youngAdults; i++) {
            room1.push('12');
        }
        for (var i = 0; i < searchParam.passengers.children; i++) {
            room1.push('2');
        }
        for (var i = 0; i < searchParam.passengers.infants; i++) {
            room1.push('0');
        }
        return {
            checkIn: moment(searchParam.checkin).format('YYYY-MM-DD'),
            checkOut: moment(searchParam.checkout).format('YYYY-MM-DD'),
            room1: room1,
            num_rooms: searchParam.passengers.rooms,
            locationValue: searchParam.location.value
        };
    };
    INDRABookingComService.prototype.resetSearchParam = function () {
        this.searchParam = {
            checkin: '',
            checkout: '',
            num_rooms: 0,
            room1: [],
            // room2: [],
            propertyType: [],
            hotelFacilities: [],
            minPrice: '',
            maxPrice: '',
            stars: [],
            locationValue: ''
        };
    };
    INDRABookingComService.prototype.setOrderBy = function (orderBy) {
        this.orderBy = orderBy;
    };
    INDRABookingComService.prototype.getOrderBy = function () {
        return this.orderBy;
    };
    INDRABookingComService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABookingComService_Factory() { return new INDRABookingComService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient), i0.inject(i3.DomSanitizer)); }, token: INDRABookingComService, providedIn: "root" });
    return INDRABookingComService;
}());
export { INDRABookingComService };
